<template>
  <div class="mb-2">
    <div class="b-form__container_type_flex">
      <checkbox class="b-checkbox" :id="`termination-${currentAssetComponent.assetId}-${currentAssetComponentIndex}`" v-model="isTermination">{{$t('CONTENT.assets.termination')}}</checkbox>
      <dynamic-icon class="ml-1" v-tooltip="$t('CONTENT.hints.terminationHint')" icon="question"></dynamic-icon>
    </div>
    <transition name="fade">
      <div class="my-4 ml-6" v-if="isTermination">
        <div>
          <checkbox class="b-checkbox" :id="`is-termination-${currentAssetComponent.assetId}-${currentAssetComponentIndex}`" v-model="terminationIsSure">{{$t('CONTENT.assets.options_is_termination')}}</checkbox>
        </div>
        <div class="row mt-4 px-0">
          <div class="col-2">
            <div class="b-form__container">
              <label>{{$t('CONTENT.date')}}:</label>
              <datepicker class="b-datepicker" v-model="terminationDate" :disabled="!terminationIsSure" :formatter="datepickerFormat" :disabled-date="endAssetComponentDate"></datepicker>
            </div>
          </div>
        </div>
        <div class="mt-4">
          <checkbox class="b-checkbox" :disabled="!terminationIsSure" :id="`termination-is-fine-presented-${currentAssetComponent.assetId}-${currentAssetComponentIndex}`" v-model="terminationIsFinePresented">{{$t('CONTENT.assets.options_is_check_fine')}}</checkbox>
        </div>
        <div class="mt-4">
          <checkbox class="b-checkbox" :disabled="!terminationIsFinePresented || !terminationIsSure" :id="`termination-is-fine-will-be-presented-${currentAssetComponent.assetId}-${currentAssetComponentIndex}`" v-model="terminationIsFineWillBePayed">{{$t('CONTENT.assets.options_is_check_fine_pay')}}</checkbox>
        </div>
        <!--Данные платежа по штрафу-->
        <div class="my-8" v-if="terminationIsSure && terminationIsFinePresented">
          <div class="row mt-5">
            <div class="col-2">
              <div>
                <label>{{$t('CONTENT.payments.payment_currency_code')}}:</label>
                <cool-select :list="currencyCodes"
                             option-value="code"
                             option-text="name"
                             :placeholder="$t('CONTENT.choose')"
                             v-model="terminationCurrencyCode"></cool-select>
              </div>
            </div>
            <div class="col-2">
              <div class="b-form__container">
                <label for="termination-external-id">{{$t('CONTENT.external_id')}}:</label>
                <input
                  data-cy="termination-external-id"
                  type="text"
                  id="termination-external-id"
                  class="b-input"
                  name="termination-external-id"
                  v-model="terminationExternalId"
                />
              </div>
            </div>
          </div>
          <div class="mt-4">
            <div class="row mt-2 b-form__container_type_flex b-form__row_type_flex-end">
              <div class="col-2" data-cy="termination-lease-rate">
                <label>{{$t('CONTENT.payments.fine_sum')}}:</label>
                <numeric class="b-numeric" controls :min="0" :max="1000000000000" v-model="terminationLeaseRate"></numeric>
              </div>
              <div class="col-2">
                <div>
                  <label>{{$t('CONTENT.payments.payment_date')}}:</label>
                  <datepicker class="b-datepicker" v-model="terminationPaymentDate" :formatter="datepickerFormat"></datepicker>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
	import dateConverter from "../../../../../utils/converters/date.converter";
	import TerminationOption from "../../../../../models/contract/TerminationOption";
	import ExtensionOption from "../../../../../models/contract/ExtensionOption";
  import datepickerFormat from '@/mixins/datepickerFormat.mixin';

	export default {
		props: {
      currentAssetComponent: {
				type: Object,
			},
      currencyCodes: {
        type: Array,
        required: true,
      },
      currentAssetComponentIndex: {
        type: Number,
      }
		},
    mixins: [datepickerFormat],
		computed: {
			isTermination: {
				get() {
					return this.currentAssetComponent.termination !== null;
				},
				set(value) {
					if(value) {
						this.$store.commit('assetComponentsPlugin/addTerminationOption', {assetId: this.currentAssetComponent.assetId, assetComponent: this.currentAssetComponent, data: TerminationOption.createNew()});
					} else {
            this.$store.commit('assetComponentsPlugin/addTerminationOption', {assetId: this.currentAssetComponent.assetId, assetComponent: this.currentAssetComponent, data: null});
					}
					this.changeTermination();
				}
			},
			terminationCurrencyCode: {
				get() {
          if(this.currentAssetComponent.termination.currencyCode !== null) {
            return this.currentAssetComponent.termination.currencyCode.toLowerCase();
          } else {
            return null;
          }
        },
        set(newVal) {
          this.$store.commit('assetComponentsPlugin/updateTerminationOption', {
            assetId: this.currentAssetComponent.assetId,
            assetComponent: this.currentAssetComponent,
            name: 'currencyCode',
            value: newVal.toUpperCase()
          });
          this.changeTermination();
        }
			},
			terminationIsSure: {
				get() {
					if(this.currentAssetComponent.termination === null) {
						return false;
					} else {
						return this.currentAssetComponent.termination.isSure;
					}
				},
				set(value) {
					if(value) {
            this.$store.commit('assetComponentsPlugin/addTerminationOption', {assetId: this.currentAssetComponent.assetId, assetComponent: this.currentAssetComponent, data: TerminationOption.createNew()});
          }

					this.$store.commit('assetComponentsPlugin/updateTerminationOption', {
						assetId: this.currentAssetComponent.assetId,
						name: 'isSure',
            assetComponent: this.currentAssetComponent,
						value: value
					});

					if (value && (this.currentAssetComponent.extension !== null && this.currentAssetComponent.extension.isSure)) {
            this.$store.commit('assetComponentsPlugin/addExtensionOption', {assetId: this.currentAssetComponent.assetId, assetComponent: this.currentAssetComponent, data: ExtensionOption.createNew()});
					}
          this.changeTermination();
				}
			},
			terminationDate: {
				get() {
					if (this.currentAssetComponent.termination === null || this.currentAssetComponent.termination.date === null) {
						return null;
					} else {
						return dateConverter.convertToDate(this.currentAssetComponent.termination.date);
					}
				},
				set(newVal) {
				  let terminationDate = null;
				  if(newVal !== null) {
            terminationDate = dateConverter.convertToString(newVal);
          }

          this.$store.commit('assetComponentsPlugin/updateTerminationOption', {
            assetId: this.currentAssetComponent.assetId,
            name: 'date',
            assetComponent: this.currentAssetComponent,
            value: terminationDate
          });

          this.changeTermination();
        }
			},
			terminationIsFinePresented: {
				get() {
					if(this.currentAssetComponent.termination === null || this.currentAssetComponent.isFinePresented === null) {
						return false;
					} else {
						return this.currentAssetComponent.termination.isFinePresented;
					}
				},
				set(value) {
					if(!value) {
            this.$store.commit('assetComponentsPlugin/updateTerminationOption', {
              assetId: this.currentAssetComponent.assetId,
              name: 'isFineWillBePayed',
              assetComponent: this.currentAssetComponent,
              value: value
            });
					}

          this.$store.commit('assetComponentsPlugin/updateTerminationOption', {
            assetId: this.currentAssetComponent.assetId,
            name: 'isFinePresented',
            assetComponent: this.currentAssetComponent,
            value: value
          });
          this.changeTermination();
				}
			},
			terminationIsFineWillBePayed: {
				get() {
					if(this.currentAssetComponent.termination === null || this.currentAssetComponent.isFineWillBePayed === null) {
						return false;
					} else {
						return this.currentAssetComponent.termination.isFineWillBePayed;
					}
				},
				set(value) {
          this.$store.commit('assetComponentsPlugin/updateTerminationOption', {
            assetId: this.currentAssetComponent.assetId,
            name: 'isFineWillBePayed',
            assetComponent: this.currentAssetComponent,
            value: value
          });
          this.changeTermination();
				}
			},
			terminationExternalId: {
				get() {
					if(this.currentAssetComponent.termination === null || this.currentAssetComponent.termination.externalId === null) {
						return null;
					} else {
						return this.currentAssetComponent.termination.externalId;
					}
				},
				set(value) {
          this.$store.commit('assetComponentsPlugin/updateTerminationOption', {
            assetId: this.currentAssetComponent.assetId,
            name: 'externalId',
            assetComponent: this.currentAssetComponent,
            value: value
          });
          this.changeTermination();
				}
			},
			terminationLeaseRate: {
				get() {
					if(this.currentAssetComponent.termination === null || this.currentAssetComponent.termination.rate === null) {
						return null;
					} else {
						return this.currentAssetComponent.termination.rate;
					}
				},
				set(newVal) {
          this.$store.commit('assetComponentsPlugin/updateTerminationOption', {
            assetId: this.currentAssetComponent.assetId,
            name: 'rate',
            assetComponent: this.currentAssetComponent,
            value: newVal
          });
          this.changeTermination();
        }
			},
			terminationPaymentDate: {
				get() {
					if(this.currentAssetComponent.termination === null || this.currentAssetComponent.termination.paymentDate === null) {
						return null;
					} else {
						return dateConverter.convertToDate(this.currentAssetComponent.termination.paymentDate);
					}
				},
				set(newVal) {
				  let terminationPaymentDate = null;
          if (newVal !== null) {
            terminationPaymentDate = dateConverter.convertToString(newVal);
          }

          this.$store.commit('assetComponentsPlugin/updateTerminationOption', {
            assetId: this.currentAssetComponent.assetId,
            name: 'paymentDate',
            assetComponent: this.currentAssetComponent,
            value: terminationPaymentDate
          });

          this.changeTermination();
        }
			}
		},
		watch: {
			terminationIsSure(val) {
				if(!val && this.isTermination) {
          this.$store.commit('assetComponentsPlugin/addTerminationOption', {assetId: this.currentAssetComponent.assetId, assetComponent: this.currentAssetComponent, data: TerminationOption.createNew()});
        }
        this.changeTermination();
			}
		},
		methods: {
      endAssetComponentDate(date) {
        if(this.currentAssetComponent.endDate !== null) {
          return date > dateConverter.convertToDate(this.currentAssetComponent.endDate);
        }
      },
      changeTermination() {
			  this.$emit('changeTermination');
      }
		}
	}
</script>
